import { buildTask as _buildTask } from "ember-concurrency/-private/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';

// import uniq from 'lodash/uniq';

function formatCheckInWindowOption(timeInSeconds) {
  return timeInSeconds === 60 ? {
    name: '1 min',
    value: 60
  } : {
    name: `${Math.floor(timeInSeconds / 60)} mins`,
    value: timeInSeconds
  };
}
let RoombaSettingsRoomCheckInComponent = (_class = class RoombaSettingsRoomCheckInComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "flashMessages", _descriptor, this);
    _initializerDefineProperty(this, "graphql", _descriptor2, this);
    _initializerDefineProperty(this, "roombaMetrics", _descriptor3, this);
    _initializerDefineProperty(this, "featureFlags", _descriptor4, this);
    _initializerDefineProperty(this, "selectedCheckInWindow", _descriptor5, this);
    _initializerDefineProperty(this, "isSettingsAndExceptionsDialogOpen", _descriptor6, this);
    _initializerDefineProperty(this, "isDialogOpen", _descriptor7, this);
    _defineProperty(this, "toggleRoomLocationCheckInEnabledTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        const {
          company,
          location
        } = this.args;
        try {
          const roomCheckInEnabledSetting = !location.roomCheckInEnabled;
          this.roombaMetrics.trackEvent(`room_check_in_${roomCheckInEnabledSetting ? 'enabled' : 'disabled'}`, {
            company_id: company.id,
            location_id: location.id
          });
          yield this.graphql.updateRoomsLocationCheckInEnabledOverride(location.id, roomCheckInEnabledSetting);
          this.flashMessages.showAndHideFlash('success', 'Saved!');
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', 'Error saving location settings');
        } finally {
          this.closeDialog();
        }
      }
    }), {
      drop: true
    }, "toggleRoomLocationCheckInEnabledTask", null));
    _defineProperty(this, "toggleRoomCompanyCheckInEnabledTask", _buildTask(() => ({
      context: this,
      generator: function* () {
        const {
          company,
          location
        } = this.args;
        try {
          const roomCheckInEnabledSetting = !location.roomCheckInEnabled;
          this.roombaMetrics.trackEvent(`room_check_in_${roomCheckInEnabledSetting ? 'enabled' : 'disabled'}`, {
            company_id: company.id
          });
          yield this.graphql.updateCompanyConfig({
            roomCheckInEnabled: roomCheckInEnabledSetting
          });
          this.flashMessages.showAndHideFlash('success', 'Saved!');
        } catch (e) {
          this.flashMessages.showAndHideFlash('error', 'Error saving company settings');
        } finally {
          this.closeDialog();
        }
      }
    }), {
      drop: true
    }, "toggleRoomCompanyCheckInEnabledTask", null));
    _defineProperty(this, "updateLocationCheckInWindow", _buildTask(() => ({
      context: this,
      generator: function* () {
        this.roombaMetrics.trackEvent('location_check_in_window_updated', {
          checkInWindow: this.selectedCheckInWindow.name
        });
        yield this.graphql.updateLocationRoomsCheckInWindow(this.args.location.id, this.selectedCheckInWindow.value, this.selectedCheckInWindow.value);
      }
    }), {
      drop: true
    }, "updateLocationCheckInWindow", null));
    _defineProperty(this, "saveRoomsTask", _buildTask(() => ({
      context: this,
      generator: function* (selectedRooms) {
        const existingCompanyExcludedRooms = this.args.excludedRooms?.checkInExcludedRooms.filter(room => room.locationId !== this.args.location.id).map(room => room.id) || [];
        const currentLocationExcludedRooms = selectedRooms.map(room => room.id);
        const roomIdsToExclude = new Set([...existingCompanyExcludedRooms, ...currentLocationExcludedRooms]);
        this.roombaMetrics.trackEvent('room_check_in_excluded_rooms_updated', {
          selectedRooms: selectedRooms.map(room => room.name)
        });
        yield this.graphql.putSpaceSaverCheckInExcludedRooms(this.args.company.id, [...roomIdsToExclude]);
      }
    }), {
      restartable: true
    }, "saveRoomsTask", null));
    this.selectedCheckInWindow = formatCheckInWindowOption(this.args.location.roomsPreCheckInWindow || 300);
  }
  openDialog() {
    this.isDialogOpen = true;
  }
  closeDialog() {
    this.isDialogOpen = false;
  }

  /**
   * @task `toggleRoomLocationCheckInEnabledTask`
   */

  /**
   * @task `toggleRoomCompanyCheckInEnabledTask`
   */

  get shouldShowCheckInSettingsAndExceptions() {
    return this.args.company.roomCheckInEnabled || this.args.location.roomCheckInEnabled;
  }
  get checkInTimeOptions() {
    return Array.from({
      length: 20
    }, (_, index) => formatCheckInWindowOption((index + 1) * 60));
  }
  async selectCheckInTimeOption(option) {
    this.selectedCheckInWindow = option;
    await this.updateLocationCheckInWindow.perform();
  }
  openSettingsAndExceptionsDialog() {
    this.isSettingsAndExceptionsDialogOpen = true;
  }
  closeSettingsAndExceptionsDialog() {
    this.isSettingsAndExceptionsDialogOpen = false;
  }
  get excludedRooms() {
    if (!this.args.excludedRooms?.checkInExcludedRooms) {
      return [];
    }
    return this.args.excludedRooms.checkInExcludedRooms.filter(room => room.locationId === this.args.location.id);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "graphql", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "roombaMetrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "featureFlags", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "selectedCheckInWindow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isSettingsAndExceptionsDialogOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isDialogOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "openDialog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeDialog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectCheckInTimeOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectCheckInTimeOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openSettingsAndExceptionsDialog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openSettingsAndExceptionsDialog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeSettingsAndExceptionsDialog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeSettingsAndExceptionsDialog"), _class.prototype)), _class);
export { RoombaSettingsRoomCheckInComponent as default };